import React, {useState} from "react";
import ContentBox from "../../../../../components/content-box/ContentBox";
import DonationTracker from "../../../../../components/donation-tracker/DonationTracker";
import DonationInfo from "../../../../../model/DonationInfo";
import PageActions from "../../../../base/PageActions";
import useFetchResult from "../../../../../hooks/UseFetchResult";
import _http_service from "../../../../../services/HttpService";
import _image_service from "../../../../../services/ImageService";
import "../../../../styles/Common.scss";
import "../CharityStreamPage.scss";

interface AlsCharityStreamPageProps {
}

const AlsCharityStreamPage = (props: AlsCharityStreamPageProps) => {

    const page: PageActions = new PageActions({
        title: `Charities: ALS - Chase the Fox`,
        description: `Learn more about Chase's efforts to help fight ALS!`,
        keywords: ["twitch", "stream info", "chasetheredfox", "charity", "als united"],
        imgSrc: `chase/assets/chase_twitch_icon.png`,
        url: `stream/charities/als`
    });

    const years: number[] = [2026, 2025, 2024, 2023];

    const [year, setYear] = useState<number>(years[0]);

    const [getResult, hasFetchedResult, setFetchedResult] = useFetchResult<DonationInfo>(undefined,
        async () => _http_service.getDonations("als", ""+year)
            .then(response => {
                if (!response) {
                    throw new Error("Could not fetch donation data!");
                }
                
                return response;
            }), [year]);

    const changeYear = (year: string): void => {
        setYear(+year);
        setFetchedResult(false);
    };

    return page.generateMetaContent(
        <>
            <ContentBox header="ALS claims all the lives it touches. We're here to stop it!">
                <div>
                    <img src={_image_service.getCdnImageSrc('chase/stream/charities/als_group_photo.png')}
                         alt="Team Dogbomb at the Triangle Walk to Fight ALS in 2022"
                         title="Team Dogbomb braving the heat!"
                         className="width-50-percent block"/>
                    <p>
                        ALS, also known as amyotrophic lateral sclerosis or Lou Gehrig's Disease, is a horrible
                        affliction. It slowly deteriorates the nervous system, robbing one of their muscle strength
                        in various parts of their body over the course of years. It can affect anyone, and it is
                        100% lethal. The ALS Association continues to raise money for ALS treatments in hopes of
                        one day finding a cure. I have also joined the <strong>Papa Barks</strong> campaign, started by
                        fellow streamer MarksBarks in his father's honor.
                    </p>
                    <p>
                        Every year, I walk along with <strong>Team Dogbomb</strong> and my local ALS Association
                        chapter to help raise money for a cure and Unlock ALS. Team Dogbomb was founded after
                        furry fandom member and marathon runner Tony "Dogbomb" Barrett came down with the disease
                        and passed away a few years after. We raise money in his name. You may see me roaming
                        around with my Unlock ALS shirt once in a while.
                    </p>
                    <p>
                        If you are able, please
                        consider <a href="https://donate.als.org/give/287064/#!/donation/checkout?c_src=chasethefox.com"
                                    target="_blank"
                                    rel="noopener noreferrer">
                            donating to the ALS Association
                        </a> or to your local chapter.
                    </p>

                    <div style={{margin: "0 auto 16px", width: "fit-content"}}>
                        <label htmlFor="go-year-select">Select a year for the event:</label>
                        <select name="go-year-select"
                                onChange={event => changeYear(event.target.value)}>
                            {years.map(y => <option key={`donation-tracker-option-${y}`}
                                                    defaultValue={year}
                                                    value={y}>{''+y}</option>)}
                        </select>
                    </div>
                    {hasFetchedResult &&
                        <DonationTracker key={`donation-tracker-go-${Object.keys(getResult()).length}`}
                                         cause={(year === 2023) ? 'ALS Triangle Walk 2023' : `Papa Barks ${year}`}
                                         donations={getResult()}/>
                    }
                </div>
            </ContentBox>
        </>
    );
}

export default AlsCharityStreamPage;